"use strict";

exports.__esModule = true;
exports.TicketTypesScreen = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _Core = require("../../Core");
var _Screen = require("../../Core/Screen");
var _Translator = require("../../Core/Translator");
var _System = require("../../../System");
var _TicketTypesToolbar = require("../TicketTypesToolbar");
var _TicketTypesListView = require("../TicketTypesListView");
var _TicketTypeListContext = require("../TicketTypeListContext");
var _AppNavbar = require("../../App/AppNavbar");
var _MasterDetailView = require("../../Core/MasterDetailView");
var _UpdateTicketTypeScreen = require("../UpdateTicketTypeScreen");
var _CreateTicketTypeScreen = require("../CreateTicketTypeScreen");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TicketTypesScreen = exports.TicketTypesScreen = (0, _reactRouterCompat.withRouter)(function (props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var history = props.history,
    match = props.match;
  var params = match.params;
  function handleSelect(selected) {
    if (selected === params.id || selected !== undefined) {
      return;
    }
    history.push((0, _System.getScreenLocation)("TicketTypes"));
  }
  return /*#__PURE__*/_react["default"].createElement(_TicketTypeListContext.TicketTypeLoader, null, function (resp) {
    if (resp === undefined || resp === null || resp.fetching) {
      return resp.fetching && /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
    }
    if (resp.error) {
      return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
        error: resp.error
      });
    }
    if (!resp.fetching && resp.data) {
      var ticketTypes = resp.data;
      return /*#__PURE__*/_react["default"].createElement(_TicketTypeListContext.TicketTypeListContext.Provider, {
        ticketTypes: ticketTypes
      }, /*#__PURE__*/_react["default"].createElement(_MasterDetailView.MasterDetailView, {
        selected: params.id,
        onSelect: handleSelect,
        renderMaster: function renderMaster() {
          return /*#__PURE__*/_react["default"].createElement(_Screen.Screen, {
            title: translate("TicketTypeScreen.title", "Ticket Types")
          }, /*#__PURE__*/_react["default"].createElement(_AppNavbar.AppNavbar, {
            title: translate("TicketTypeScreen.navbar.title", "Ticket Types")
          }), /*#__PURE__*/_react["default"].createElement(_TicketTypesToolbar.TicketTypesToolbar, null), /*#__PURE__*/_react["default"].createElement(_TicketTypesListView.TicketTypesListView, null));
        },
        renderDetail: function renderDetail() {
          return /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.RootRoutes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
            path: (0, _System.getScreenPath)("UpdateTicketType"),
            element: /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.CompatRoute, {
              component: _UpdateTicketTypeScreen.UpdateTicketTypeScreen
            })
          }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
            path: (0, _System.getScreenPath)("CreateTicketType"),
            element: /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.CompatRoute, {
              component: _CreateTicketTypeScreen.CreateTicketTypeScreen
            })
          }));
        }
      }));
    }
  });
});